import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { country } from '../enums/language';
import { LocalStorageService } from './localStorage.service';
import { TimezoneService } from './timezone.service';
import { ZorroLanguageSwitcherService } from './zorro-language-switcher.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  constructor(
    private _localStorage: LocalStorageService,
    private translateService: TranslateService,
    private zorroLanguageSwitcher: ZorroLanguageSwitcherService,
    private timezone : TimezoneService,
    private route: ActivatedRoute,
  ) {}

  setLanguage(lang: string) {
    this.translateService.use(lang);
    this.zorroLanguageSwitcher.switchZorroLanguage(lang);
    return this._localStorage.set('language', lang);
  }
  setDialCode(code:string){
    this._localStorage.set('pos_dial_code', code);
  }
  setLocale(locale:string){
    this._localStorage.set('locale', locale );
  }
  setAcceptLanguage(lang:string){
    this._localStorage.set('accept-language', lang );
  }
  setCountry(country:string){
    this._localStorage.set('country', country );
  }
  getCountry(){
    return this._localStorage.get('country');
  }

  getLanguage() {
    return this._localStorage.get('language');
  }
  getDialCode() {
    return this._localStorage.get('pos_dial_code');
  }
  getLocale() {
    return this._localStorage.get('locale');
  }
  getAcceptLanguage(){
    return this._localStorage.get('accept-language');
  }
  getDomain(){
    return window.location.hostname.split('.').pop() === 'localhost' ? 'ai' :  window.location.hostname.split('.').pop()
  }

  setCountryData(lang?,countryVar?){
      const domain = this.getDomain();
      const languageVar = this.getLanguage()
      if(!lang && !languageVar ){
      this.setLanguage(country[domain].language);
      this.setAcceptLanguage(country[domain].acceptLanguage)
      }else if(lang){
        this.setLanguage(lang);
        this.setAcceptLanguage(country[lang])
      }
      this.timezone.setTimeZone(country[domain].timezone)
      if(!countryVar){
      this.setCountry(country[domain].country)
      }else{
        this.setCountry(countryVar)
      }
      this.setDialCode(country[domain].dialCode)
      this.setLocale(country[domain].locale)
  }
}
